import Box from "@mui/material/Box";
import { alpha } from "@mui/material/styles";

import TemplateMessagePreview from "./TemplateMessagePreview";

const FRAME_VARIANTS = {
  compact: {
    height: { xs: 330, md: 296 },
    pr: 1,
  },
  dialog: {
    height: { xs: 360, sm: 460 },
    pr: 0.5,
  },
  inline: {
    height: { xs: 330, md: 262 },
    pr: 1,
  },
  selector: {
    height: { xs: 330, md: 347 },
    pr: 1,
  },
};

export default function TemplateMessagePreviewFrame({
  children,
  height,
  parameters,
  preview,
  showParameterState = false,
  sx,
  variant = "selector",
}) {
  const variantConfig = FRAME_VARIANTS[variant] || FRAME_VARIANTS.selector;

  return (
    <Box
      sx={[
        (theme) => ({
          height: height || variantConfig.height,
          minHeight: 0,
          overscrollBehavior: "contain",
          overflowY: "auto",
          pr: variantConfig.pr,
          scrollbarColor: `${alpha(theme.palette.text.secondary, 0.45)} transparent`,
          scrollbarWidth: "thin",
          "&::-webkit-scrollbar": {
            width: 8,
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: alpha(theme.palette.text.secondary, 0.35),
            borderRadius: 999,
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children || (
        <TemplateMessagePreview
          parameters={parameters}
          preview={preview}
          showParameterState={showParameterState}
        />
      )}
    </Box>
  );
}
